import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import { Table, Button, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';

const RegistrationList = () => {
  const navigate = useNavigate();
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRegistrations = async () => {
    try {
      setLoading(true);
      const response = await axios.get('https://ward3-chandrapur-api.palikaapp.com/api/registration/all');
      setRegistrations(response.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegistrations();
  }, []);

  if (loading) {
    return <Spin size="large" />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columns = [
    {
      title: 'दर्ताको मिति',
      dataIndex: 'registrationDate',
      key: 'registrationDate',
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: 'पत्र पठाउने मानिस/सँस्था',
      dataIndex: 'pageSendingPersonOrOrganization',
      key: 'pageSendingPersonOrOrganization',
    },
    {
      title: 'पत्र पठाउनेको ठेगाना',
      dataIndex: 'registrationLocation',
      key: 'registrationLocation',
    },
    {
      title: 'बिषय',
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: 'पत्रको प्रकार',
      dataIndex: 'pageLength',
      key: 'pageLength',
    },
  ];
  const rowClassName = (record, index) => {
    return index % 2 === 0 ? 'odd-row' : 'even-row';
  };


  return (
    <div>
      <Header />
      <div className="pt-20">
      <Sidebar />
      <div className="ml-0 md:ml-56 mt-6 px-4 md:px-6">
        <h1 className="text-2xl font-bold mb-4 pt-5 px-5">दर्ताको सुची</h1>

        {/* Button to Add Registration */}
        <div className="mb-4 flex justify-end">
          <Button
            type="primary"
            className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
            onClick={() => navigate('/registration/add')}
          >
            थप
          </Button>
        </div>

        {/* Table Wrapper for responsiveness */}
        <div className="overflow-x-auto p-5">
          <div className="inline-block min-w-full">
            <Table
              dataSource={registrations}
              columns={columns}
              pagination={false}
              rowKey={(record) => record.registrationDate}
              className='custom-table'
              rowClassName={rowClassName}
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default RegistrationList;
